<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleDateChange="handleDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div>
        </div>
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.financial.enterCashFlow'" @click="handle('create')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('financial.enterCashFlow') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" v-permission="'setting.financial.editCashFlow'" @click="handle('edit', props.record)">
                    <icon-edit size="13" style="marginRight:5px;" />
                    {{ $t('base.edit') }}
                </a-button>
            </template>

        </Table>

        <!-- 新建目标 -->
        <a-modal
            v-model:visible="visible" 
            draggable
            :onBeforeOk="onBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('financial.enterCashFlow') }}</div> 
            </template>
            
            <Form
                :form="addForm"
                @handleInputNumberChange="handleInputNumberChange"
            ></Form>
        </a-modal>
        
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { CashFlowQueryForm, AddCashFlowForm } from './queryConfig/FinancialQuery'
    import { dateToTimestamp, timestampToDate} from '@/utils/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()

    const queryForm = reactive(CashFlowQueryForm)
    const addForm = reactive(AddCashFlowForm)
    const visible = ref(false)
    const operateType = ref('add')
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'left',
            },
            // {
            //     // title: '年份',
            //     title:t('financial.year'),
            //     dataIndex: 'year',
            //     key:'year',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            // {
            //     // title: '月',
            //     title:t('financial.month'),
            //     dataIndex: 'month',
            //     key:'month',
            //     align:'center',
            //     ellipsis:true,
            //     tooltip:true,
            // },
            {
                // title: '日期',
                title:t('financial.recordTimestamp'),
                dataIndex: 'record_timestamp',
                key:'record_timestamp',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: '流入',
                title:t('financial.amountIn'),
                dataIndex: 'amount_in',
                key:'amount_in',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '流出',
                title:t('financial.amountOut'),
                dataIndex: 'amount_out',
                key:'amount_out',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '现金流合计',
                title:t('financial.amountTotal'),
                dataIndex: 'amount_total',
                key:'amount_total',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '260',
                align: 'center',
                fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                cashAndAccountList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                break;
            case 'create':
                addForm.formField.forEach(item=>{
                    addForm.formData[item.key] = ''
                    if(item.key == 'record_timestamp'){
                        item.disabled = false
                    }
                })
                visible.value = true
                operateType.value = 'add'
            case 'edit':
                addForm.formField.forEach(item=>{
                    if(item.key == 'amount_out'){
                        addForm.formData[item.key] = Number(row[item.key].split(' ')[1].replace('-',' ').trim())
                    }else if(item.key == 'amount_in'){
                        addForm.formData[item.key] = Number(row[item.key].split(' ')[1])
                    }else if(item.key == 'amount_total'){
                        addForm.formData[item.key] = row[item.key].split(' ')[1].indexOf('-') > 0? Number(row[item.key].split(' ')[1].replace('-',' ').trim()) : Number(row[item.key].split(' ')[1])
                    }else if(item.key == 'record_timestamp'){
                        addForm.formData[item.key] = row[item.key]
                        item.disabled = true
                    }
                })
                addForm.formData.id = row.id
                visible.value = true    
                operateType.value = 'edit'
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        cashAndAccountList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        cashAndAccountList()
    }

    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        cashAndAccountList()
    }

    const handleDateChange = ()=>{
        table.value.configs.pagination.current = 1
        cashAndAccountList()
    }

    const handleInputNumberChange = (item,val,inputVal)=>{
        console.log(item,val,inputVal,'item,val,inputVal')
        console.log(addForm.formData.amount_in !== '' && addForm.formData.amount_out !== '','ggg')
        if(addForm.formData.amount_in !== '' && addForm.formData.amount_out !== ''){
            console.log(addForm.formData.amount_out.toString().indexOf('-') > -1,'sss')
            addForm.formData.amount_out = addForm.formData.amount_out.toString().indexOf('-') > -1? Number(addForm.formData.amount_out.toString().replace('-',' ').trim()) : addForm.formData.amount_out
            addForm.formData.amount_total = subtract(addForm.formData.amount_in, addForm.formData.amount_out)
        }
    }

    const cashAndAccountList = async ()=>{
        console.log(queryForm.formData.record_timestamp,'kkk')
        let param = {
            model:'CASH',
        }
        if(queryForm.formData.record_date !== '') param.record_date = queryForm.formData.record_date

        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await FinancialApi.getInstance().cashAndAccountList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item, index)=>{
                console.log(`-${item.amount_out}`)
                item.No = index + 1
                item.record_timestamp = timestampToDate(item.record_timestamp * 1000).split(' ')[0]
                item.amount_in = item.amount_in === 0? '€ ' + 0 : `€ ${item.amount_in}`
                item.amount_out = item.amount_out === 0? '€ ' + 0 : item.amount_out.toString().indexOf('-') > -1? `€ ${item.amount_out}` : `€ -${item.amount_out}`
                item.amount_total = item.amount_total === 0? '€ ' + 0 : `€ ${item.amount_total}`
            })
            table.value.datas = res.data.records
            table.value.configs.loading = false
            table.value.configs.pagination.total = res.data.total
        }else{
            Message.error(res.msg)
        }
    }

    const onBeforeOk = async ()=>{
        // console.log(addForm.formData,'校验')
        if(!addForm.formData.record_timestamp){
            Message.error(t('financial.recordTimestamp') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.amount_in === ''){
            Message.error(t('financial.amountIn') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.amount_out === ''){
            Message.error(t('financial.amountOut') + ' ' + t('base.noEmpty'))
            return false
        }

        let formData = {}
        if(operateType.value == 'add'){
            addForm.formField.forEach(i=>{
                if(i.key !== 'id'){
                    formData[i.key] = addForm.formData[i.key]
                }
            })
        }else{
            formData = addForm.formData
        }

        let param = {
            model:'CASH',   
            ...formData,
            amount_out: formData.amount_out.toString().indexOf('-') > -1? formData.amount_out : Number(`-${formData.amount_out}`),
            record_timestamp: dateToTimestamp(formData.record_timestamp)
        }
        console.log(param,'param')
        let res = await FinancialApi.getInstance().saveCashAndAccount([param])
        if(res.code == 0){
            Message.success(t('base.createSuccess'))
            cashAndAccountList()
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        cashAndAccountList()
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}
</style>